import FlexPane from './_flex-pane.js'
import Image from './_image.js'
import ToggleButton from './_toggle-button.js'

export default {
  name: 'SubscribeEventsToggle',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {},
    },
    bellIcon: {
      configSet: Image,
      configValues: {
        src: 'bell',
        style: {
          minWidth: '12px',
          minHeight: '12px',
        },
      },
    },
    toggleButton: {
      configSet: ToggleButton,
      configValues: {
        mainContainer: {
          style: {
            alignItems: 'center',
          },
        },
        activeLabel: {
          container: {
            padding: '0 0 0 8px',
          },
        },
        inactiveLabel: {
          container: {
            padding: '0 0 0 8px',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
